import { useSelector } from "react-redux";
import { useCallback } from "react";
import { amplitudeTrack } from "helpers/utility/amplitude";
import {
  AMP_DATASET_EXPLORATION_PROPERTY__FILTER_TYPE,
  AMP_DATASET_EXPLORATION_PROPERTY__CONTEXT,
  AMP_DATASET_EXPLORATION_PROPERTY__ENTITY_TYPE,
} from "helpers/constants/amplitudeProperties";
import {
  AMP_DATASET_EXPLORATION_EVENT__FILTER__APPLIED,
  AMP_DATASET_EXPLORATION_EVENT__FILTER__REMOVED,
} from "helpers/constants/amplitudeEvents";
import { TrackingFilterTypes, FilterOption } from "types";
import { getEntityTypeFilter } from "redux/SingleDataset/selectors";
import { State } from "redux/store";
import useQueryParam from "./useQueryParam";
import { ENTITY_TYPE_PARAMETER } from "helpers/constants/miscellaneous";
import { isValidEntityType } from "types";
const useAmplitudeTrackFilterEvent = (
  type: TrackingFilterTypes,
  context: "Dataset" | "Metadata Summary"
) => {
  const entityParam = useQueryParam(ENTITY_TYPE_PARAMETER);
  const entityTypeFromQueryParam = isValidEntityType(entityParam)
    ? entityParam
    : null;
  const entityTypeFilter = useSelector((state: State) =>
    getEntityTypeFilter(state, entityTypeFromQueryParam)
  );

  const trackFilterEvent = useCallback(
    (changeType: "Added" | "Removed") => {
      const selectedEntities = entityTypeFilter
        .filter((entity: FilterOption) => entity.selected)
        .map((entity: FilterOption) => entity.text);

      const value =
        selectedEntities.length > 0 ? selectedEntities.join(",") : "Images";

      const properties = {
        [AMP_DATASET_EXPLORATION_PROPERTY__FILTER_TYPE]: type,
        [AMP_DATASET_EXPLORATION_PROPERTY__CONTEXT]: context,
        [AMP_DATASET_EXPLORATION_PROPERTY__ENTITY_TYPE]: value,
      };

      const event =
        changeType === "Added"
          ? AMP_DATASET_EXPLORATION_EVENT__FILTER__APPLIED
          : AMP_DATASET_EXPLORATION_EVENT__FILTER__REMOVED;

      amplitudeTrack(event, properties);
    },
    [entityTypeFilter, type, context]
  );

  return trackFilterEvent;
};

export default useAmplitudeTrackFilterEvent;
